module.exports = __webpack_public_path__ + "img/banner.cd00a92.jpg";